/**
 * Coordinator Style02 - Stitch v2: gold theme
 */
import type { TraitControlProps } from './types'
import { getTraitConfig } from './traitStyleConfig'
import './CoordinatorStyle02.css'

export function CoordinatorStyle02({ state }: TraitControlProps) {
  const { icon } = getTraitConfig('Coordinator')
  const status = (state?.status ?? state?.online ?? state?.connected) as boolean | string | undefined
  const isOnline = status === true || status === 'online' || status === 'connected' || String(status).toLowerCase() === 'true'

  return (
    <div className="trait-coordinator-style02 trait-stitch-v2-glass">
      <div className="trait-coordinator-style02__header">
        <span className="trait-coordinator-style02__title">Coordinator</span>
        <span className={`material-symbols-outlined trait-coordinator-style02__icon`}>{icon}</span>
      </div>
      <div className="trait-coordinator-style02__status">
        <span className={`material-symbols-outlined trait-coordinator-style02__status-icon ${isOnline ? 'online' : ''}`}>
          hub
        </span>
        <span className="trait-coordinator-style02__status-text">{isOnline ? 'Online' : 'Offline'}</span>
      </div>
    </div>
  )
}
